/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/**
 * Generate a loading state layout based on provided arrays of objects (rows of
 * columns). Aliases are set up for common parts of our app, to keep this more
 * readable / descriptive.
 *
 * @param {number} width Translates to .col-{number} class from bootstrap
 * @param {number} lineHeight Height of one gray line, in rem unit
 * @param {number} lines Number of gray lines to render
 * @param {boolean} random Randomize width of each gray line (70 - 100%)
 */

// Block aliases
const block = {
  title: {
    width: 8,
    lineHeight: 3,
    lines: 1,
    random: true,
  },
  description: {
    width: 7,
    lineHeight: 1,
    lines: 4,
    random: true,
  },
  descriptionWide: {
    width: 8,
    lineHeight: 1,
    lines: 12,
    random: true,
  },
  descriptionWideMediumLines: {
    width: 8,
    lineHeight: 1,
    lines: 8,
    random: true,
  },
  descriptionNarrow: {
    width: 4,
    lineHeight: 1,
    lines: 12,
    random: true,
  },
  tab: {
    width: 1,
    lineHeight: 1,
    lines: 1,
    random: false,
  },
  objAttribute: {
    width: 4,
    lineHeight: 1,
    lines: 2,
    random: true,
  },
  input: {
    width: 12,
    lineHeight: 'input',
    lines: 1,
    random: false,
  },
  label: {
    width: 5,
    lineHeight: 1,
    lines: 1,
    random: false,
  },
  comments: {
    width: 4,
    lineHeight: 2,
    lines: 2,
    random: true,
  },
  attachments: {
    width: 8,
    lineHeight: 2,
    lines: 2,
    random: false,
  },
};

export const layouts = {
  ObjectInfo: [
    [block.title],
    [],
    [block.description],
    [],
    [block.objAttribute, block.objAttribute, block.objAttribute],
    [],
    [],
    [block.tab, block.tab, block.tab, block.tab],
    [],
  ],
  JiraIssue: [[block.title], [], [block.descriptionWide, block.descriptionNarrow]],
  ServicenowTask: [[block.title], [], [block.description]],
  EditCard: [[block.label], [block.input]],
  EvidenceCollection: [
    [block.title, block.comments],
    [],
    [block.descriptionWideMediumLines, block.comments],
    [],
    [block.attachments, block.comments],
    [],
    [],
    [],
    [],
    [block.input],
  ],
  default: [[block.title], [], [block.description]],
};

export interface layoutColumn {
  width: number;
  lineHeight: number | string;
  lines: number;
  random: boolean;
}
